import { render, staticRenderFns } from "./UploadJobDescriptionFile.vue?vue&type=template&id=564741b4&scoped=true"
import script from "./UploadJobDescriptionFile.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadJobDescriptionFile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UploadJobDescriptionFile.vue?vue&type=style&index=0&id=564741b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564741b4",
  null
  
)

export default component.exports